import logo from './logo.svg';
import './App.css';
import ResponsiveAppBar from './Components/ResponsiveAppBar';
import PatientAnagraphic from './Pages/PatientAnagraphic';
import ParametriVitaliTable from './Pages/ParametriVitaliTable';
import AccertInfermOrchestrator from './Pages/AccertInfermOrchestrator';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Home from './Pages/Home';

function App() {
  return (
      <BrowserRouter>
        <ResponsiveAppBar/>
        <div className='App-header'>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/anagrafica" element={<PatientAnagraphic />} />
          <Route path="/parametrivitali" element={<ParametriVitaliTable />} />
          <Route path="/accertamentoinfermieristico" element={<AccertInfermOrchestrator />} />
          <Route path="*" element={<Home />} />
      </Routes>
          </div>
    </BrowserRouter>
  );
}

export default App;
